/* eslint-disable max-len */
export const enums = {
    account_status: {
        ACTIVE: 'Active',
        CLOSED: 'Closed',
        DORMANT: 'Dormant',
        SUSPENDED: 'Suspended'
    },
    account_type: {
        FUND: 'Fund',
        ISA: 'ISA',
        ISAFUND: 'ISA Fund',
        PLATFORM: 'Platform',
        FEE: 'Fee'
    },
    activity_scope: {
        GLOBAL: 'Global',
        LOCAL: 'Local',
        TASK: 'Task',
        USER: 'User'
    },
    additional_needs_type: {
        HEARING: 'Hearing',
        VISUAL: 'Visual',
        COGNITIVE: 'Cognitive',
        LITERACY_NUMERACY: 'Literacy/Numeracy',
        NEURODIVERSE: 'Neurodiverse',
        PHYSICAL_LONG_TERM_ILLNESS: 'Physical/Long Term Illness',
        TERMINAL_ILLNESS: 'Terminal Illness',
        MENTAL_HEALTH: 'Mental Health',
        BLOCKED_ACCESS: 'Blocked Access',
        EMOTIONAL_LIFE_CHANGE: 'Emotional Life Change',
        FINANCIAL_HARDSHIP: 'Financial Hardship',
        TEMPORARY_ILL_HEALTH: 'Temporary Ill Health',
        UNEMPLOYMENT_REDUNDANCY: 'Unemployment/Redundancy',
        TECHNOLOGY_ISSUES: 'Technology Issues'
    },
    additional_needs_type_description: {
        HEARING:
            'You have a hearing impairment such as deafness, hearing loss or tinnitus, or a communication impairment which means you have difficulties when talking or speaking with us.',
        VISUAL: 'You’re blind or have low or poor vision or have another condition such as cataracts or colour blindness.',
        COGNITIVE: 'You have a mild cognitive impairment or dementia, affecting your memory, language or behaviour.',
        LITERACY_NUMERACY: 'You need support with reading and writing and/or basic maths in everyday life.',
        NEURODIVERSE:
            'You have a neurodiverse condition such as autism, dyslexia or ADHD and you want us to be aware so that we can better support you when you are in touch with us.',
        PHYSICAL_LONG_TERM_ILLNESS:
            'You have a physical disability or a long-term illness that reduces your abilities and may need support with some products, services or task.',
        TERMINAL_ILLNESS: 'You have a life limiting illness. If you need urgent support, please contact us.',
        MENTAL_HEALTH:
            'You live with a long-term mental health condition that affects your daily life. You want to make us aware so that we can better support you.',
        BLOCKED_ACCESS:
            'You are having difficulties with someone who must not be given access to your information, even if they have the correct personal information, such as a restraining order, stalker or domestic abuse.',
        EMOTIONAL_LIFE_CHANGE:
            'Your circumstances have changed, and you need some extra support when you contact us, for example divorce or a bereavement.',
        FINANCIAL_HARDSHIP:
            'You’ve had a change in your financial circumstances and may need support with bills or your account. If you need urgent help or want to understand how you may be able to release funds, contact us.',
        TEMPORARY_ILL_HEALTH:
            'You’re living with a health condition that impacts your daily life and you want to make us aware so that we can better support you.',
        UNEMPLOYMENT_REDUNDANCY: 'You’re no longer employed and may need support.',
        TECHNOLOGY_ISSUES:
            'You have problems with reliably accessing email or have difficulty working with or managing technology in general, such as mobile phones, internet access or computers. You would prefer that we communicate with you via paper documents or telephone calls and may need your financial adviser or an advocate to help you with the documentation. You can add this additional need in addition to any other need that indicates a disability, impairment or situation to explicitly request paper documentation.'
    },
    custody_account_status: {
        ACTIVE: 'Active',
        INACTIVE: 'Inactive',
        PENDING: 'Pending'
    },
    custody_account_status_toggle_text: {
        ACTIVE: 'Disable',
        INACTIVE: 'Requested',
        PENDING: 'Verified'
    },
    custody_account_status_toggle_tooltip: {
        ACTIVE: 'Disable the custody account',
        INACTIVE: 'Click to confirm that the custody account has been requested',
        PENDING: 'Click to confirm that the custody account has been verified'
    },
    commercial_tier: {
        UNCONTRACTED: 'Uncontracted',
        TIER_1: 'Tier 1',
        TIER_2: 'Tier 2',
        TIER_3: 'Tier 3'
    },
    adviser_commercial_tier: {
        UNCONTRACTED: 'Uncontracted',
        TIER_1: 'Tier 1',
        TIER_2: 'Tier 2'
    },
    adviser_commercial_tier_description: {
        UNCONTRACTED: 'No platform access.',
        TIER_1: 'Standard platform access.',
        TIER_2: 'Not implemented. Do not use.'
    },
    fund_manager_commercial_tier: {
        UNCONTRACTED: 'Uncontracted',
        TIER_1: 'Tier 1',
        TIER_2: 'Tier 2',
        TIER_3: 'Tier 3'
    },
    fund_manager_commercial_tier_description: {
        UNCONTRACTED: 'Marketing view of offers and the ability to upload offer media.',
        TIER_1: 'Can see offers, clients list, client portfolios, investment reports and branding.',
        TIER_2: 'All of tier 1 and provides access to most areas of the platform. Does not allow the provider to add clients who are not already contracted either by GI PC or by an adviser firm.',
        TIER_3: 'All of Tier 2 plus the ability to add and manage their own client base on the platform.'
    },
    provider_commercial_tier: {
        UNCONTRACTED: 'Uncontracted',
        TIER_1: 'Tier 1',
        TIER_2: 'Tier 2',
        TIER_3: 'Tier 3'
    },
    provider_commercial_tier_description: {
        UNCONTRACTED: 'Marketing view of offers and the ability to upload offer media.',
        TIER_1: 'Can see offers, clients list, client portfolios, investment reports and branding.',
        TIER_2: 'All of tier 1 and provides access to most areas of the platform. Does not allow the provider to add clients who are not already contracted either by GI PC or by an adviser firm.',
        TIER_3: 'All of Tier 2 plus the ability to add and manage their own client base on the platform.'
    },
    email_disposition: {
        QUEUED: 'Queued',
        SENT: 'Sent',
        DELIVERED: 'Delivered',
        REJECTED: 'Rejected',
        BOUNCED: 'Bounced',
        COMPLAINED: 'Complained',
        OPENED: 'Opened',
        DELAYED: 'Delayed'
    },
    viewing_restriction_status: {
        NONE: 'Normal',
        WARNING: 'Warning',
        RESTRICTED: 'Restricted'
    },
    viewing_restriction_description: {
        NONE: 'There are no restrictions. The investor will be able to freely navigate through their portfolio.',
        WARNING:
            'There are no restrictions. The investor will be able to freely navigate through their portfolio but a non-dismissible banner will display a warning.',
        RESTRICTED:
            'Fully restricted. The investor will not be able to navigate through their portfolio and instead will be presented with a message explaining why their account is restricted.'
    },
    viewing_restriction_success: {
        NONE: 'The investor will be able to freely navigate through their portfolio.',
        WARNING:
            'The investor will be able to freely navigate through their portfolio but a non-dismissible banner will display a warning.',
        RESTRICTED:
            'The investor will not be able to navigate through their portfolio and instead will be presented with a message explaining why their account is restricted.'
    },
    loa_status: {
        MISSING: 'Missing',
        REQUESTING: 'Requesting',
        PENDING: 'Pending',
        COMPLETED: 'Completed'
    },
    loa_source: {
        UPLOADED: 'Uploaded',
        GENERATED: 'Generated'
    },
    loa_type: {
        APPLICATION: 'Application',
        INVESTOR_LOA: 'Investor LOA',
        OTHER: 'Other'
    },
    payment_frequency: {
        NO_AUTO: 'Off',
        MONTHLY: 'Monthly',
        QUARTERLY: 'Quarterly'
    },
    fee_frequency: {
        ANNUAL: 'Annual',
        MONTHLY: 'Monthly'
    },
    fee_frequency_per: {
        ANNUAL: 'Year',
        MONTHLY: 'Month'
    },
    fee_group: {
        INVESTOR: 'Investor',
        INVESTEE_COMPANY: 'Investee Company',
        OTHER: 'Other'
    },
    fee_selector: {
        BOOLEAN: 'Boolean',
        MONEY: 'Money',
        MULTIPLIER: 'Multiplier',
        NUMERIC: 'Numeric',
        PERCENTAGE: 'Percentage',
        TEXT: 'Text'
    },
    fee_type: {
        INITIAL: 'Initial',
        ANNUAL_MANAGEMENT: 'Annual Management',
        CUSTODY: 'Custody',
        DEALING: 'Dealing',
        OTHER_INITIAL: 'Other Initial',
        OTHER_ONGOING: 'Other Ongoing',
        PERFORMANCE: 'Performance',
        EXIT: 'Exit',
        INVESTEE_INITIAL: 'Investee Initial',
        INVESTEE_ANNUAL_MANAGEMENT: 'Investee Annual Management',
        INVESTEE_ADMINISTRATION: 'Investee Administration',
        INVESTEE_DEALING: 'Investee Dealing',
        INVESTEE_MENTORING: 'Investee Mentoring',
        INVESTEE_OTHER: 'Investee Other',
        INVESTEE_BOARD: 'Investee Board',
        DEPLOYMENT_FACTOR: 'Deployment Factor',
        AIC_ONGOING: 'AIC Ongoing',
        EXPENSE_CAP: 'Expense Cap'
    },
    fee_tax_type: {
        EIS: 'EIS',
        SEIS: 'SEIS',
        IHT: 'IHT',
        VCT: 'VCT',
        PMI: 'PMI'
    },
    activity_type: {
        ACCOUNT: 'Account',
        ACTIVITY: 'Activity',
        APPLICATION: 'Application',
        DETAILCREATE: 'Detail Create',
        DETAILDELETE: 'Detail Delete',
        DETAILEDIT: 'Detail Edit',
        DETAILVIEW: 'Detail View',
        ONBOARDING: 'Onboarding',
        OTHER: 'Other',
        PORTFOLIO: 'Portfolio',
        PROPOSAL: 'Proposal',
        REGISTRATION: 'Registration',
        SECURITY: 'Security'
    },
    address_type: {
        BILL: 'Billing',
        MAIL: 'Mail',
        NONE: 'None',
        REGISTERED: 'Registered'
    },
    esign_envelope_status: {
        DRAFT: 'Draft',
        CREATED: 'Created',
        SENT: 'Sent',
        IN_PROGRESS: 'In Progress',
        DECLINED: 'Declined',
        CANCELLED: 'Cancelled',
        EXPIRED: 'Expired',
        SIGNED: 'Signed'
    },
    esign_participant_role: {
        SIGNER: 'Signer',
        APPROVER: 'Approver',
        CERTIFIED_RECIPIENT: 'Certified Recipient',
        NOTARY_SIGNER: 'Notary Signer',
        ELECTRONIC_SEALER: 'Electronic Sealer',
        COPY_RECIPIENT: 'Copy Recipient'
    },
    agreement_status: {
        ACCEPTED: 'Accepted',
        APPROVED: 'Approved',
        ARCHIVED: 'Archived',
        AUTHORING: 'Authoring',
        CANCELLED: 'Cancelled',
        DELIVERED: 'Delivered',
        DOCUMENTS_NOT_YET_PROCESSED: 'Documents not yet processed',
        DRAFT: 'Draft',
        EXPIRED: 'Expired',
        FORM_FILLED: 'Form filled',
        null: 'Not set',
        OUT_FOR_ACCEPTANCE: 'Awaiting acceptance',
        OUT_FOR_APPROVAL: 'Awaiting approval',
        OUT_FOR_DELIVERY: 'Awaiting delivery',
        OUT_FOR_FORM_FILLING: 'Awaiting form filling',
        OUT_FOR_SIGNATURE: 'Awaiting signature',
        PREFILL: 'Pre-fill',
        SIGNED: 'Signed',
        WAITING_FOR_FAXIN: 'Awaiting faxin',
        WAITING_FOR_NOTARIZATION: 'Awaiting notarization',
        WAITING_FOR_VERIFICATION: 'Awaiting verification',
        WIDGET_WAITING_FOR_VERIFICATION: 'Widget awaiting verification'
    },
    alert_type: {
        ERROR: 'Error',
        INFO: 'Info',
        SUCCESS: 'Success',
        WARNING: 'Warning'
    },
    application_status: {
        AWAITING_ADVISER_SIGNATURE: 'Awaiting Adviser Signature',
        AWAITING_INVESTOR_SIGNATURE: 'Awaiting Client Signature',
        COMPLETE: 'Complete',
        PENDING: 'Pending'
    },
    contact_number_type: {
        LANDLINE: 'Landline',
        MOBILE: 'Mobile',
        OFFICE: 'Office'
    },
    derivative_exercise_type: {
        AMERICAN: 'American',
        EUROPEAN: 'European'
    },
    derivative_settlement_period: {
        PERIOD: 'Period'
    },
    derivative_settlement_type: {
        CASH: 'Cash',
        PHYSICAL: 'Physical'
    },
    disposal_type: {
        EXIT: 'Exit',
        FAILURE: 'Failure'
    },
    disposition_result: {
        EXIT: 'Exit',
        FAIL: 'Fail',
        NONE: 'None',
        SOLD: 'Sold',
        MERGED: 'Merged'
    },
    dividend_type: {
        FINAL: 'Final',
        INTERIM: 'Interim',
        SPECIAL: 'Special'
    },
    dri_share_type: {
        PRIMARY: 'Primary',
        // DRIS
        SECONDARY: 'Secondary' // DRIP
    },
    dynamic_form_element_type: {
        CUSTOM: 'Custom',
        STANDARD: 'Standard'
    },
    dynamic_form_type: {
        ARRAY: 'Array',
        BOOLEAN: 'Boolean',
        DATE: 'Date',
        DATETIME: 'Datetime',
        ENUM: 'Enum',
        MONEY: 'Money',
        NUMBER: 'Number',
        PERCENTAGE: 'Percentage',
        STRING: 'String'
    },
    fee_collection: {
        DIRECT: 'Direct from the client',
        FACILITATED_PLATFORM: 'Facilitated through the platform',
        FACILITATED_PROVIDER: 'Facilitated by the provider'
    },
    fund_status: {
        CLOSED: 'Closed',
        EVERGREEN: 'Evergreen',
        OPEN: 'Open'
    },
    fund_type: {
        EIS: 'EIS',
        IHT: 'IHT',
        OTHER: 'Other',
        PMI: 'PMI',
        SEIS: 'SEIS',
        SEISEIS: 'SEIS/EIS'
    },
    holding_status: {
        DRAFT: 'Draft',
        OPEN: 'Open',
        CLOSED: 'Closed'
    },
    holding_allotment_status: {
        ALLOTMENT_EXCEEDS_PROPOSED_AMOUNT: 'Allotment Exceeds Proposed Amount',
        ALLOTTED: 'Allotted',
        IN_PROGRESS: 'In Progress',
        PENDING: 'Pending',
        REJECTED: 'Rejected'
    },
    icon_style: {
        FAD: 'Duotone',
        FAL: 'Light',
        FAR: 'Regular',
        FAS: 'Solid',
        FAT: 'Thin'
    },
    iht_type: {
        AIM: 'Aim',
        ASSET: 'Asset'
    },
    investor_account_stage: {
        APPLICATION: 'Application',
        APPROPRIATENESS: 'Appropriateness',
        AUTHORISATION: 'Authorisation',
        BANK_ACCOUNT: 'Bank Account',
        CATEGORISATION: 'Categorisation',
        PROFILE: 'Profile',
        REGISTRATION: 'Registration'
    },
    investor_account_stage_status: {
        COMPLETE: 'Complete',
        ERROR: 'Error',
        INCOMPLETE: 'Incomplete',
        WARNING: 'Warning'
    },
    investor_category: {
        CERTIFIED_SOPHISTICATED: 'Sophisticated (Certified)',
        ELECTIVE_PROFESSIONAL: 'Professional (Elective)',
        HIGH_NET_WORTH: 'High Net Worth',
        PROFESSIONAL: 'Professional (Per-se)',
        RETAIL_ADVISED: 'Retail (Advised)',
        RETAIL_RESTRICTED: 'Retail (Restricted)',
        SELF_CERT_SOPHISTICATED: 'Sophisticated (Self Certified)'
    },
    investor_registration_status: {
        APPLYING: 'Applying',
        COMPLETE: 'Complete',
        ONBOARDING: 'Onboarding',
        REGISTERING: 'Registering'
    },
    investor_structure: {
        CORPORATE: 'Corporate',
        INDIVIDUAL: 'Individual',
        PENSION: 'Pension',
        TRUST: 'Trust'
    },
    investor_type: {
        CERTIFIED_SOPHISTICATED: 'Sophisticated (Certified)',
        ELECTIVE_PROFESSIONAL: 'Professional (Elective)',
        HIGH_NET_WORTH: 'High Net Worth',
        PROFESSIONAL: 'Professional (Per-se)',
        RETAIL_ADVISED: 'Retail (Advised)',
        RETAIL_RESTRICTED: 'Retail (Restricted)',
        SELF_CERT_SOPHISTICATED: 'Sophisticated (Self Certified)'
    },
    market_cap_source: {
        CALCULATED: 'Calculated',
        COMPANY: 'Company',
        MORNINGSTAR: 'Morningstar'
    },
    marketing_consent: {
        SOFTNO: 'No',
        SOFTYES: 'Yes',
        HARDNO: 'No',
        HARDYES: 'Yes'
    },
    media_adviser_type: {
        FEES: 'Client Fees',
        FEES_CHARGES_STATEMENT: 'Adviser Fee Statement',
        TERMS: 'Terms & Conditions'
    },
    media_format: {
        DOC: 'Document',
        IMAGE: 'Image',
        VIDEO: 'Video'
    },
    media_investor_type: {
        APPLICATION_FORM: 'Application / Subscription Document',
        CAPITAL_CALL_NOTICE: 'Capital Call Notice',
        CATEGORISATION_CERTIFICATE: 'Categorisation Certificate',
        COMMUNICATION: 'Investor Communication',
        CONTRACTUAL: 'Contract Note',
        DISTRIBUTION_NOTICE: 'Distribution Notice',
        EIS_CERTIFICATE: 'EIS Certificate',
        EXIT_LETTER: 'Exit Letter',
        FEE_ILLUSTRATION: 'Fee Illustration',
        FINANCIAL: 'Investor Financial Statement',
        IDENTITY: 'Identity Document',
        LEGAL: 'Investor Legal Document',
        LOA: 'Letter of Authority',
        LOSS_RELIEF_LETTER: 'Loss Relief Letter',
        OTHER: 'Other',
        PLATFORM_APPLICATION: 'Platform Application',
        SEIS_CERTIFICATE: 'SEIS Certificate',
        SHARE_CERTIFICATE: 'Share Certificate',
        TAX_CERTIFICATE: 'VCT Tax Certificate',
        TAX_REPORT: 'Tax Report',
        VALUATION: 'Valuation / Capital Account Statement'
    },
    media_marketing_type: {
        APPLICATION: 'Application',
        CERTIFICATION: 'Certification',
        DD: 'Due Diligence',
        IM: 'Information Memorandum',
        INVESTMENT_DECK: 'Investment Deck',
        KEY_INFORMATION_DOCUMENT: 'Key Information Document',
        KID: 'Key Information Document',
        OTHER: 'Other',
        PROSPECTUS: 'Prospectus',
        SUMMARY: 'Summary',
        SUSTAINABLE_DISCLOSURE: 'Sustainable Disclosure'
    },
    media_type: {
        ADVISER: 'Adviser',
        BRANDING: 'Branding',
        INVESTOR: 'Investor',
        MARKETING: 'Marketing'
    },
    month: {
        APR: 'April',
        AUG: 'August',
        DEC: 'December',
        FEB: 'February',
        JAN: 'January',
        JUL: 'July',
        JUN: 'June',
        MAR: 'March',
        MAY: 'May',
        NOV: 'November',
        OCT: 'October',
        SEP: 'September'
    },
    offer_status: {
        CLOSED: 'Closed',
        COMING_SOON: 'Coming Soon',
        EVERGREEN: 'Evergreen',
        OPEN: 'Open'
    },
    offer_type: {
        MULTIPLE: 'Multiple',
        NEW: 'New',
        TOPUP: 'Topup'
    },
    offer_workflow_status: {
        DRAFT: 'Draft',
        LIVE: 'Live'
    },
    offer_workflow_status_description: {
        DRAFT: 'Offer is not visible to investors/advisers.',
        LIVE: 'Offer is visible to investors/advisers.'
    },
    offers_tabs: {
        all: 'All',
        eis_seis: 'EIS and SEIS Funds',
        esg: 'ESG and Sustainable Investments',
        iht: 'IHT and Estate Planning Services',
        pmi: 'Private Market Funds',
        single_company: 'Single Company',
        vct: 'Venture Capital Trusts'
    },
    offers_heading: {
        all: 'All Offers',
        eis_seis: 'EIS and SEIS Fund Offers',
        esg: 'ESG and Sustainable Investment Offers',
        iht: 'IHT and Estate Planning Services Offers',
        pmi: 'Private Market Fund Offers',
        single_company: 'Single Company Offers',
        vct: 'Venture Capital Trust Offers'
    },
    holding_action: {
        EDIT_HOLDING: 'Edit Holding',
        MERGE_HOLDING: 'Merge Holding'
    },
    event_type: {
        DAILY_NOTIFICATION_REMINDER: 'Daily Notification Reminder',
        INVESTOR_MEDIA_CREATED: 'Investor Media Created',
        INVESTOR_MEDIA_CREATED_MULTIPLE: 'Multiple Investor Media Created',
        INVESTOR_ACCOUNT_AUTHORISED: 'Investor Account Authorised',
        PROPOSAL_CREATED: 'Proposal Created',
        PROPOSAL_STATUS_UPDATED: 'Proposal Status Updated',
        PROPOSAL_COMPLETED: 'Proposal Completed',
        SHORTLIST_NEEDS_ADVISER_FEES: 'Shortlist Needs Adviser Fees'
    },
    event_type_description: {
        DAILY_NOTIFICATION_REMINDER: 'A daily notification email will be sent to you.',
        INVESTOR_MEDIA_CREATED: 'A new media item has been created for an investor.',
        INVESTOR_MEDIA_CREATED_MULTIPLE: 'Multiple media items have been created for an investor.',
        INVESTOR_ACCOUNT_AUTHORISED: "An investor's account has been authorised.",
        PROPOSAL_CREATED: 'A new proposal has been created.',
        PROPOSAL_STATUS_UPDATED: 'A proposal has been updated.',
        PROPOSAL_COMPLETED: 'A proposal has been completed.',
        SHORTLIST_NEEDS_ADVISER_FEES: 'A shortlist requires adviser fees before it can be proposed.'
    },
    notification_action: {
        MARK_ALL_AS_READ: 'Mark all as read',
        CLEAR_ALL_READ: 'Clear all read'
    },
    notification_transport: {
        WEB: 'Web',
        EMAIL: 'Email'
    },
    notification_group: {
        GENERAL: 'General',
        INVESTOR: 'Investor',
        ADVISER: 'Adviser',
        PRIMARY_CONTACT: 'Primary Contact',
        PROVIDER: 'Provider',
        FUND_MANAGER: 'Fund Manager',
        COMPANY: 'Company'
    },
    notification_group_info: {
        GENERAL: 'General platform notifications.',
        INVESTOR: 'Notifications about investors where the user is the investor.',
        ADVISER: 'Notifications about investors visible to the user and any other notification types.',
        PRIMARY_CONTACT: 'Notifications about investors where the user is the primary contact.',
        PROVIDER: 'Notifications about investors where the user is the provider.',
        FUND_MANAGER: 'Notifications about investors where the user is the fund manager.',
        COMPANY: 'Notifications about investors where the user is the company.'
    },
    notification_type: {
        DAILY_NOTIFICATION_REMINDER: 'Daily Notification Reminder',
        //
        INVESTOR_MEDIA_CREATED_INVESTOR: 'Investor Media Created (Investor)',
        INVESTOR_MEDIA_CREATED_PRIMARY_CONTACT: 'Investor Media Created (Primary Contact)',
        INVESTOR_MEDIA_CREATED_ADVISER: 'Investor Media Created (Adviser)',
        //
        INVESTOR_MEDIA_CREATED_MULTIPLE_INVESTOR: 'Multiple Investor Media Created (Investor)',
        INVESTOR_MEDIA_CREATED_MULTIPLE_PRIMARY_CONTACT: 'Multiple Investor Media Created (Primary Contact)',
        INVESTOR_MEDIA_CREATED_MULTIPLE_ADVISER: 'Multiple Investor Media Created (Adviser)',
        //
        INVESTOR_ACCOUNT_AUTHORISED_INVESTOR: 'Investor Account Authorised (Investor)',
        INVESTOR_ACCOUNT_AUTHORISED_PRIMARY_CONTACT: 'Investor Account Authorised (Primary Contact)',
        INVESTOR_ACCOUNT_AUTHORISED_ADVISER: 'Investor Account Authorised (Adviser)',
        //
        PROPOSAL_CREATED_INVESTOR: 'Proposal Created (Investor)',
        PROPOSAL_CREATED_PRIMARY_CONTACT: 'Proposal Created (Primary Contact)',
        PROPOSAL_CREATED_ADVISER: 'Proposal Created (Adviser)',
        PROPOSAL_CREATED_PROVIDER: 'Proposal Created (Provider)',
        PROPOSAL_CREATED_FUND_MANAGER: 'Proposal Created (Fund Manager)',
        PROPOSAL_CREATED_COMPANY: 'Proposal Created (Company)',
        //
        PROPOSAL_STATUS_UPDATED_INVESTOR: 'Proposal Status Updated (Investor)',
        PROPOSAL_STATUS_UPDATED_PRIMARY_CONTACT: 'Proposal Status Updated (Primary Contact)',
        PROPOSAL_STATUS_UPDATED_ADVISER: 'Proposal Status Updated (Adviser)',
        PROPOSAL_STATUS_UPDATED_PROVIDER: 'Proposal Status Updated (Provider)',
        PROPOSAL_STATUS_UPDATED_FUND_MANAGER: 'Proposal Status Updated (Fund Manager)',
        PROPOSAL_STATUS_UPDATED_COMPANY: 'Proposal Status Updated (Company)',
        //
        PROPOSAL_COMPLETED_INVESTOR: 'Proposal Completed (Investor)',
        PROPOSAL_COMPLETED_PRIMARY_CONTACT: 'Proposal Completed (Primary Contact)',
        PROPOSAL_COMPLETED_ADVISER: 'Proposal Completed (Adviser)',
        PROPOSAL_COMPLETED_PROVIDER: 'Proposal Completed (Provider)',
        PROPOSAL_COMPLETED_FUND_MANAGER: 'Proposal Completed (Fund Manager)',
        PROPOSAL_COMPLETED_COMPANY: 'Proposal Completed (Company)',
        //
        SHORTLIST_NEEDS_ADVISER_FEES_PRIMARY_CONTACT: 'Shortlist Needs Adviser Fees (Primary Contact)',
        SHORTLIST_NEEDS_ADVISER_FEES_ADVISER: 'Shortlist Needs Adviser Fees (Adviser)'
    },
    permission_group: {
        USER: 'User',
        CLIENT_USER: 'Client User',
        ORGANISATION: 'Organisation',
        INVESTMENT: 'Investment',
        TRANSACTION: 'Transaction',
        REPORT: 'Report',
        ASSET: 'Asset',
        ASSET_VALUE: 'Asset Value',
        CHILD_USER: 'Child User',
        ADVISER: 'Adviser',
        INVESTOR: 'Investor',
        PRODUCT: 'Product',
        OFFER: 'Offer',
        DISCLOSURE: 'Disclosure',
        ANY_ORGANISATION: 'Any Organisation',
        ANY_USER: 'Any User',
        BULK: 'Bulk',
        REGISTRATION: 'Registration',
        INVESTOR_VISIBILITY_GROUP: 'Investor Visibility Group',
        HOLDING: 'Holding',
        TERMS: 'Terms',
        SHARE_VALUATION: 'Share Valuation',
        MISC: 'Miscellaneous'
    },
    permission_group_info: {
        USER: 'Permissions to manage users within your own organisation.',
        CLIENT_USER: 'Permissions to manage users within your clients organisations.',
        ORGANISATION: 'Permissions to manage my own organisation.',
        INVESTMENT: 'Permissions to manage investments.',
        TRANSACTION: 'Permissions to manage transactions.',
        REPORT: 'Permissions to manage reports.',
        ASSET: 'Permissions to manage assets.',
        ASSET_VALUE: 'Permissions to manage asset values.',
        CHILD_USER: 'Permissions to manage child users.',
        ADVISER: 'Permissions to manage advisers.',
        INVESTOR: 'Permissions to manage investors.',
        PRODUCT: 'Permissions to manager products.',
        OFFER: 'Permissions to manage offers.',
        DISCLOSURE: 'Permissions to manage disclosures.',
        ANY_ORGANISATION: 'Permissions to manage any organisation.',
        ANY_USER: 'Permissions to manage any user.',
        BULK: 'Permissions to bulk import/export.',
        REGISTRATION: 'Permissions to view and approve registrations.',
        INVESTOR_VISIBILITY_GROUP: 'Permissions to manage visibility groups.',
        HOLDING: 'Permissions to allot holdings.',
        TERMS: 'Permissions to manage terms and conditions.',
        SHARE_VALUATION: 'Permissions to manage product share valuations.',
        MISC: 'Miscellaneous.'
    },
    offer_action: {
        EDIT_OFFER: 'Edit Offer',
        PREVIEW_OFFER: 'Preview Offer',
        VIEW_OFFER: 'View Offer',
        COPY_OFFER: 'Copy Offer',
        DELETE_OFFER: 'Delete Offer',
        MANAGE_MEDIA: 'Manage Media'
    },
    onboarding_status: {
        AML: 'AML Verification',
        COMPLETE: 'Complete',
        ONBOARDING: 'Onboarding',
        REGISTRATION: 'Registration'
    },
    organisation_status: {
        ACTIVE: 'Active',
        INACTIVE: 'Inactive',
        SUSPENDED: 'Suspended',
        UNVERIFIED: 'Unverified'
    },
    organisation_type: {
        ADVISER: 'Adviser',
        BROKER: 'Broker',
        COMPANY: 'Company',
        CUSTODIAN: 'Custodian',
        FUND_MANAGER: 'Fund Manager',
        GROWTH_INVEST: 'GrowthInvest',
        INVESTOR: 'Investor',
        NOMINEE: 'Nominee',
        PRODUCT_PROVIDER: 'Product Provider',
        RECEIVINGAGENT: 'Receiving Agent',
        REGISTRAR: 'Registrar'
    },
    phone_number_type: {
        HOME: 'Home',
        MOBILE: 'Mobile',
        OTHER: 'Other',
        WORK: 'Work'
    },
    pmi_structure: {
        AIF: 'AIF',
        FUND: 'Fund',
        LIMITED_PARTNERSHIP: 'Limited Partnership',
        LTAF: 'LTAF',
        ELTIF: 'ELTIF',
        PRODUCT: 'Product',
        SICAV: 'SICAV',
        UNIT_TRUST: 'Unit Trust'
    },
    portfolio_detail_tabs: {
        eis_seis: 'EIS and SEIS Funds',
        esg: 'ESG and Sustainable Investments',
        iht: 'IHT and Estate Planning Services',
        pmi: 'Private Market Funds',
        single_company: 'Single Company',
        summary: 'Summary',
        vct: 'Venture Capital Trusts'
    },
    product_status: {
        CLOSED: 'Closed',
        EVERGREEN: 'Evergreen',
        OPEN: 'Open'
    },
    product_type: {
        CONVERTIBLELOAN: 'Convertible Loan',
        EQUITY: 'Equity',
        HYBRID: 'Hybrid',
        LOAN: 'Loan',
        OPTION: 'Option',
        UNIT: 'Unit',
        WARRANT: 'Warrant'
    },
    product_action: {
        RESYNC_PRICING: 'Resync Pricing',
        MANAGE_VALUATIONS: 'Valuation Management'
    },
    profile_status: {
        COMPLETE: 'Complete',
        PENDING: 'Pending'
    },
    proposal_advised: {
        PROFESSIONAL: 'No - Professional Client',
        XO: 'No - Execution Only',
        YES: 'Yes'
    },
    proposal_advised_description: {
        PROFESSIONAL:
            'I am a Professional Client (as per COBS 3.5) and have received a restricted service or am proceeding on an Execution Only basis.',
        XO: 'I have not received financial advice and I am proceeding on an Execution Only basis.',
        YES: 'I have received financial advice, or I am an adviser investing on behalf of myself.'
    },
    proposal_application_status: {
        ABORTED: 'Aborted',
        EXPIRED: 'Expired',
        PENDING: 'Pending',
        SENT: 'Sent',
        SIGNED: 'Signed'
    },
    proposal_direct_marketing_method: {
        EMAIL: 'Notifications by email',
        POST: 'Notifications by post',
        POST_DOCUMENTS: 'Physical copies of documents by post'
    },
    proposal_funding_source: {
        BUSINESS_PROFIT: 'Company Profit',
        BUSINESS_SALE: 'Company Sale',
        EMPLOYMENT: 'Employment Income',
        GIFT: 'Gift',
        INHERITANCE: 'Inheritance',
        INVESTMENT_ASSETS: 'Sales of Shares, Bonds, Securities or Other Investment Assets',
        PROPERTY: 'Sale of Property'
    },
    proposal_funding_status: {
        AWAITING_FUNDS: 'Awaiting Funds',
        FUNDS_AVAILABLE: 'Funds Available',
        FUNDS_CLEARED: 'Funds Cleared',
        FUNDS_TRANSFERRED: 'Funds Transferred'
    },
    proposal_investment_status: {
        COMPLETED: 'Completed',
        PENDING_ALLOTMENT: 'Pending Allotment',
        REJECTED: 'Rejected'
    },
    proposal_redistribution: {
        REALLOCATE: 'Reallocate',
        REALLOCATE_APPLIED: 'Reallocate Applied',
        REALLOCATE_EQUALLY: 'Reallocate Equally',
        RETURN: 'Return Funds',
        RETURN_TOTAL: 'Return Total'
    },
    proposal_redistribution_description: {
        REALLOCATE:
            'Reallocate the funds from the closed product into only the products I applied for and split the funds proportionally on my original amounts',
        REALLOCATE_APPLIED: 'Reallocate equally but only among those I applied for that remain open',
        REALLOCATE_EQUALLY:
            'Reallocate the funds from the closed product equally into all the products that are open (even if I didn’t originally apply for some of them)',
        RETURN: 'Return only the funds for the product which closed',
        RETURN_TOTAL: 'Return all funds and cancel the application'
    },
    proposal_solve_amount_for: {
        APPLICATION_AMOUNT: 'Fees Added',
        CLEARED_FUNDS: 'Fees Deducted'
    },
    proposal_solve_amount_for_description: {
        APPLICATION_AMOUNT: 'I would like any fees to be added to the investment amount I provide',
        CLEARED_FUNDS: 'I would like any fees to be deducted from the total investment amount I provide'
    },
    proposal_status: {
        ABORTED: 'Aborted',
        AWAITING_APPROVAL: 'Awaiting Approval',
        AWAITING_CONFIRMATION: 'Awaiting Confirmation',
        COMPLETED: 'Completed',
        IN_PROGRESS: 'In Progress',
        PENDING_ALLOTMENT: 'Pending Allotment',
        PROPOSED: 'Proposed',
        REJECTED: 'Rejected',
        SCHEDULED: 'Scheduled',
        SHORTLISTED: 'Shortlisted'
    },
    registration_status: {
        COMPLETE: 'Complete',
        FAILED_CLASSIFICATION: 'Failed Classification',
        PENDING: 'Pending'
    },
    remote_application_action: {
        COPY_REMOTE_APPLICATION: 'Copy',
        CREATE_REMOTE_APPLICATION: 'Create',
        DELETE_REMOTE_APPLICATION: 'Delete',
        EDIT_REMOTE_APPLICATION: 'Edit',
        SUBMIT_REMOTE_APPLICATION: 'Submit',
        VIEW_REMOTE_APPLICATION: 'View'
    },
    remote_application_block_funds_status: {
        CLEARED: 'Cleared',
        FULLY_CLEARED: 'Fully Cleared',
        NONE: 'None',
        OUTSTANDING: 'Outstanding'
    },
    remote_application_block_status: {
        ALLOTTED: 'Allotted',
        NONE: 'None',
        REJECTED: 'Rejected',
        RETURNED: 'Returned',
        RFA: 'Ready for allotment',
        SUBMITTED: 'Submitted',
        WITHDRAWN: 'Withdrawn'
    },
    remote_application_builder_action: {
        LOAD_DATA_TEMPLATE: 'Load Data Template',
        LOAD_JINJA_TEMPLATE: 'Load Jinja2 Template',
        SAVE_DATA_TEMPLATE: 'Save Data Template',
        SAVE_JINJA_TEMPLATE: 'Save Jinja2 Template'
    },
    remote_application_status: {
        ACCEPTED: 'Accepted',
        DRAFT: 'Draft',
        REJECTED: 'Rejected',
        SENT: 'Sent'
    },
    reports_tabs: {
        adviser_activity: 'Adviser Activity',
        adviser_documents_activity: 'Adviser Documents',
        adviser_marketing_activity: 'Offers and Shortlists',
        adviser_security_activity: 'Login and Security',
        auth_activity: 'Auth Activity',
        cash_fees: 'Cash and Fees',
        client_portfolio: 'Client Portfolio',
        client_summary: 'Client Summary',
        clients_custodial_accounts: 'Clients Custodial Accounts',
        disposals: 'Disposals',
        disposals_failures: 'Failures',
        disposals_sales: 'Sales',
        dividend_transactions: 'Dividend Transactions',
        holdings: 'Holdings',
        integration_holdings: 'Holdings',
        integration_tranches: 'Tranches',
        investments: 'Investments',
        investments_eis_seis: 'EIS and SEIS Funds',
        investments_iht: 'IHT and Estate Planning Services',
        investments_pmi: 'Private Market Funds',
        investments_single_company: 'Investee Companies',
        investments_vct: 'Venture Capital Trusts',
        investor_activity: 'Investor Activity',
        investor_documents_activity: 'Investor Documents',
        investor_flow_activity: 'Proposals and Investments',
        investor_marketing_activity: 'Offers and Shortlists',
        investor_security_activity: 'Login and Security',
        library_activity: 'Library Activity',
        negligible_value: 'Negligible Value',
        notifications: 'Notifications',
        pending_applications: 'Pending Applications',
        pmi_tranches: 'PMI Tranches',
        position_reconciliation: 'Position Reconciliation',
        proposals: 'Proposals',
        registrations: 'Registrations',
        tax_year: 'Tax Year',
        tax_return: 'Tax Return',
        tranches: 'Non-PMI Tranches',
        transaction_reconciliation: 'Transaction Reconciliation',
        transactions_cash_deposits: 'Cash Deposits',
        transactions_cash_withdrawals: 'Cash Withdrawals',
        transactions_fee: 'Fee Transactions',
        transactions_income: 'Income Transactions',
        vct_maturity: 'VCT Maturity'
    },
    sdr_label: {
        CHARACTERISTICS: 'Sustainability Characteristics',
        FOCUS: 'Sustainability Focus',
        IMPACT: 'Sustainability Impact',
        IMPROVERS: 'Sustainability Improvers',
        MIXED_GOALS: 'Sustainability Mixed Goals',
        NO_LABEL: 'No Sustainability Label'
    },
    sfdr_category: {
        ARTICLE_6: 'Article 6',
        ARTICLE_8: 'Article 8',
        ARTICLE_9: 'Article 9',
        NO_CATEGORY: 'No SFDR Category'
    },
    sfdr_category_description: {
        ARTICLE_6: 'Funds without a sustainability scope',
        ARTICLE_8: 'Funds that promote environmental or social characteristics',
        ARTICLE_9: 'Funds that have sustainable investment as their objective'
    },
    settings_tabs: {
        agreements: 'Agreements',
        appropriateness: 'Appropriateness',
        appropriateness_questionnaire: 'Appropriateness Questionnaire',
        additional_needs: 'Additional Needs',
        billing: 'Fees & Charges',
        branding: 'Branding',
        communication: 'Communication',
        corporate_profile: 'Corporate Profile',
        declarations: 'Declarations',
        external_users: 'External Users',
        fee_plan_management: 'Fee Plan Management',
        financial: 'Financial',
        firm_information: 'Firm Information',
        integrations: 'Integrations',
        intermediary: 'Intermediary',
        introduction: 'Introduction',
        investor_bank_account: 'Bank Account',
        investors: 'Investors',
        network_setup: 'Network Setup',
        profile: 'Profile',
        providers: 'Providers',
        restricted_offer_panels: 'Restricted Offer Panels',
        security: 'Security',
        users: 'Users',
        visibility_groups: 'Visibility Groups',
        letters_of_authority: 'Letters of Authority'
    },
    target_dividend_type: {
        ABSOLUTE: 'Absolute',
        YIELD: 'Yield'
    },
    adviser_export_integration_type: {
        SPRINT_IO: 'Sprint IO'
    },
    integration_type: {
        MANUAL: 'Manual',
        CITYPARTNERSHIP: 'City Partnership'
    },
    integration_status: {
        ENABLED: 'Enabled',
        DISABLED: 'Disabled'
    },
    tax_status: {
        ALTS: 'Alternative Investments',
        EIS: 'Enterprise Investment Schemes',
        HYBRID: 'Hybrid Investments',
        IHT: 'Inheritance Tax and Business Relief Services',
        NQ: 'Non-Qualifying for Tax Relief',
        null: '-',
        OTHER: 'Other',
        PMI: 'Private Market Products',
        SEIS: 'Seed Enterprise Investment Schemes',
        SEISEIS: 'Seed Enterprise Investment Schemes & Enterprise Investment Schemes',
        SINGLE_COMPANY: 'Single Company',
        SITR: 'Social Investment Tax Relief Schemes',
        VCT: 'Venture Capital Trusts'
    },
    tax_status_short: {
        ALTS: 'ALTS',
        EIS: 'EIS',
        HYBRID: 'Hybrid',
        IHT: 'IHT',
        NQ: 'NQ',
        null: '-',
        OTHER: 'Other',
        PMI: 'PMI',
        SEIS: 'SEIS',
        SEISEIS: 'SEIS/EIS',
        SINGLE_COMPANY: 'SC',
        SITR: 'SITR',
        VCT: 'VCT'
    },
    terms_action: {
        CREATE_TERMS: 'Create',
        VIEW_TERMS: 'View',
        EDIT_TERMS: 'Edit',
        PUBLISH_TERMS: 'Publish',
        COPY_TERMS: 'Copy',
        DELETE_TERMS: 'Delete'
    },
    terms_status: {
        APPROVED: 'Live',
        DRAFT: 'Draft',
        SUPERCEDED: 'Superseded'
    },
    terms_type: {
        null: 'Global',
        GLOBAL: 'Global',
        ADVISER: 'Adviser',
        BROKER: 'Broker',
        COMPANY: 'Company',
        CUSTODIAN: 'Custodian',
        FUND_MANAGER: 'Fund Manager',
        INVESTOR: 'Investor',
        NOMINEE: 'Nominee',
        PRODUCT_PROVIDER: 'Product Provider',
        RECEIVINGAGENT: 'Receiving Agent',
        REGISTRAR: 'Registrar'
    },
    tranche_action: {
        DELETE_TRANCHE: 'Delete Tranche'
    },
    transaction_action: {
        CHANGE_AMOUNTS_AND_SHARES: 'Change Amounts and Share Quantity',
        CHANGE_FUND_AMOUNT: 'Change Initial Fund Investment Amount',
        CHANGE_PRODUCT: 'Change Product',
        CHANGE_SALE_AMOUNT: 'Change Amount',
        DELETE_TRANSACTION: 'Delete Transaction',
        TOGGLE_ON_OFF_PLATFORM: 'Toggle On/Off Platform'
    },
    transaction_status: {
        COMPLETE: 'Complete'
    },
    transaction_type: {
        ADJUSTMENT: 'Adjustment',
        AGREEMENT: 'Agreement',
        CASH_RECEIPT: 'Cash Receipt',
        CASH_WITHDRAWAL: 'Cash Withdrawal',
        CONTRIBUTION: 'Contribution',
        CUSTODY_TRANSFER: 'Custody Transfer',
        DISTRIBUTION: 'Distribution',
        DIVIDEND: 'Dividend',
        ESCROW: 'Escrow',
        EXIT: 'Exit',
        FEE_ADVISER: 'Adviser Fee',
        FEE_PARTNER: 'Partner Fee',
        FEE_PLATFORM: 'Platform Fee',
        FEE_PRODUCT: 'Product Fee',
        FEE_PROVIDER: 'Provider Fee',
        FUND_INVESTMENT: 'Fund Investment',
        FUND_TRANSFER: 'Fund Transfer',
        INTEREST: 'Interest',
        OPERATING_EXPENSE: 'Operating Expense',
        PM_UPDATE: 'PM Update',
        PURCHASE: 'Purchase',
        RD_PAYMENT: 'RD Payment',
        REBATE: 'Rebate',
        SALE: 'Sale',
        TAX_ADJUSTMENT: 'Tax Adjustment',
        FEE_PLATFORM_ACCRUAL: 'Platform Fee Accrual',
        FEE_PLATFORM_MISC: 'Misc Platform Fee',
        FEE_ADVISER_INITIAL_ACCRUAL: 'Initial Adviser Fee Accrual',
        FEE_ADVISER_ONGOING_ACCRUAL: 'Ongoing Adviser Fee Accrual',
        FEE_ADVISER_INITIAL: 'Initial Adviser Fee',
        FEE_ADVISER_ONGOING: 'Ongoing Adviser Fee',
        SWAP_SELL: 'Share Swap (Sell)',
        SWAP_BUY: 'Share Swap (Buy)'
    },
    update_frequency: {
        ANNUALLY: 'Annually',
        BIANNUALLY: 'Biannually',
        DAILY: 'Daily',
        FORTNIGHTLY: 'Fortnightly',
        HOURLY: 'Hourly',
        MONTHLY: 'Monthly',
        QUARTERLY: 'Quarterly',
        WEEKLY: 'Weekly'
    },
    user_role: {
        ACCOUNTANT: 'Accountant',
        ACCOUNTS: 'Accounts',
        ADMINISTRATOR: 'Administrator',
        ADVISER: 'Adviser',
        CONTENT_APPROVER: 'Content Approver',
        DIRECTOR: 'Director',
        ENTREPRENEUR: 'Entrepreneur',
        FUND_MANAGER_AUDITOR: 'Fund Manager Auditor',
        MANAGEMENT: 'Management',
        MANAGER: 'Manager',
        MARKETING: 'Marketing',
        OPERATIONS: 'Operations',
        OWNER: 'Owner',
        PLATFORM_SUPERADMIN: 'Platform Superadmin',
        READONLY: 'Read-only',
        SUPERUSER: 'Superuser',
        USER: 'Investor User'
    },
    user_status: {
        ACTIVE: 'Active',
        INACTIVE: 'Inactive',
        SUSPENDED: 'Suspended',
        UNVERIFIED: 'Unverified'
    },
    user_tax_certificate_destination: {
        ACCOUNTANT: 'Accountant',
        ADVISER: 'Adviser',
        CLIENT: 'Client'
    },
    valuation_origin: {
        COMPANIES_HOUSE: 'Companies House',
        FUND_MANAGER: 'Fund Manager',
        GAZETTE: 'Gazette',
        GROWTHINVEST: 'GrowthInvest',
        MORNINGSTAR: 'Morningstar'
    },
    valuation_type: {
        FUND: 'Fund',
        GROWTHINVEST: 'GrowthInvest',
        INSOLVENT: 'Insolvent',
        STOCK_EXCHANGE: 'Stock Exchange'
    },
    valuation_disposition: {
        NONE: 'None',
        SOLD: 'Sold',
        EXIT: 'Exit',
        FAIL: 'Fail',
        SPLIT: 'Split'
    },
    vct_dividend_reinvestment: {
        DRIP: 'DRIP',
        DRIS: 'DRIS',
        NONE: 'None'
    },
    vct_fund_status: {
        ACQUIRED: 'Acquired',
        CLOSED: 'Closed',
        OPEN: 'Open'
    },
    quarantine_status: {
        CREATED_BY_API: 'Created By API',
        CREATED_BY_ADVISER: 'Created By Adviser',
        PUBLISHED: 'Published'
    },
    relationship_type: {
        ADVISERS: 'Advisers',
        INVESTORS: 'Investors',
        OFFERS: 'Offers'
    }
};

export default enums;
